<template>
  <footer class="footer">
    <div class="container footer-inner">
      <div class="footer-brand">
        <img :src="logo" alt="芊荨科技" />
        <span>芊荨科技</span>
      </div>
      <p class="footer-desc">
        专注 Windows 平台效率工具开发 · 本地运行 · 稳定可靠 · 持续迭代
      </p>
      <a href="mailto:mtysoft@qq.com" class="footer-email">mtysoft@qq.com</a>
    </div>
    <div class="container footer-bottom">
      <span>&copy; 2026 鄂州市芊荨科技有限公司</span>
      <span>鄂ICP备2026004369号</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      logo: require('@/assets/leaf_logo_clean.png')
    }
  }
}
</script>

<style scoped>
.footer {
  background: var(--surface-dark);
  color: rgba(255, 255, 255, 0.55);
  padding: 56px 0 0;
  margin-top: auto;
}

.footer-inner {
  text-align: center;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.footer-brand img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.footer-brand span {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.02em;
}

.footer-desc {
  font-size: 14px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.45);
  max-width: 480px;
  margin: 0 auto 16px;
}

.footer-email {
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  padding: 6px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--radius);
  transition: color var(--motion-fast), border-color var(--motion-fast), background var(--motion-fast);
}

.footer-email:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.04);
}

.footer-bottom {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 24px;
  padding: 18px 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.28);
}

@media (max-width: 640px) {
  .footer-inner { padding-bottom: 32px; }
  .footer-desc { font-size: 13px; }
  .footer-bottom { flex-direction: column; align-items: center; gap: 4px; }
}
</style>
